module.exports = __webpack_public_path__ + "img/worksbot_img20022504.575b67ed.jpg";